import React from "react"
import { SiteInfo, Events, GallerySlider, Steps, Team, Callouts, Faq, DonateForm, Marquee, MissionStatement, ImageBlock, TwoColumnBlock } from "./slices"

const SliceZone = ({ slices, faq, events, allpages, gallery, page, steps, callouts, team, donate_form, marquee }) => {
  const sliceComponents = {
    site_info: SiteInfo,
    events: Events,
    gallery_slider: GallerySlider,
    steps: Steps,
    callouts: Callouts,
    faq: Faq,
    team: Team,
    donate_form: DonateForm,
    marquee: Marquee,
    mission_statement: MissionStatement,
    image_block: ImageBlock,
    two_column_block: TwoColumnBlock,
  }

  return slices.map((slice, index) => {
    const SliceComponent = sliceComponents[slice.slice_type]
    if (SliceComponent) {
      return (
        <SliceComponent
          slice={slice}
          allpages={allpages}
          faq={faq}
          events={events}
          gallery={gallery}
          page={page}
          steps={steps}
          callouts={callouts}
          team={team}
          donate_form={donate_form}
          key={`slice-${index}`}
        />
      )
    }
    return null
  })
}

export default SliceZone
